/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Accordion, AccordionSummary, Box, Button, Grid, TextField, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';

import { ToolsDetails } from '../../components/custom';
import { LayoutBase } from '../../layouts';
import { Add, ExpandMore, Remove } from '@mui/icons-material';
import { ConstructiveProjectServices, IConstructiveProject } from '../../services/api/constructive-project/ConstructiveProjectServices';
import { ConstructiveStepsServices, IConstructiveSteps } from '../../services/api/constructive-project/ConstructiveStepsServices';
import { CustomAlert } from '../../components/shared';

export const TechnicalCharacteristicsProjectDetails: React.FC = () => {

  const url = useParams();
  const navigate = useNavigate();
  const [dataProject, setDataProject] = useState<IConstructiveProject>({
    quantidade_etapas_previstas: 0,
    quantidade_etapas_executadas: 0,
    historico_construtivo: '',
    metodo_construtivo: '',
  });
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));
  const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
    open: false,
    message: '',
    severity: 'success'
  });

  const [dataSteps, setDataSteps] = useState<IConstructiveSteps[]>([]);
  const [validationsProject, setValidationsProject] = useState<{ [key: string]: boolean }>({
    quantidade_etapas_previstas: false,
    quantidade_etapas_executadas: false,
    historico_construtivo: false,
    metodo_construtivo: false,
  });

  useEffect(() => {
    fetchDataProject();
  }, []);

  const fetchDataProject = () => {
    if (url && url.dam) {
      ConstructiveProjectServices.get(url.dam, false)
        .then((result) => {
          if (result instanceof Error) {
            console.log(result.message);
          } else {
            setDataProject(result);
            fetchDataSteps();
          }
        });
    }
  };

  const fetchDataSteps = () => {
    if (url && url.project) {
      ConstructiveStepsServices.get(url.project)
        .then((result) => {
          if (result instanceof Error) {
            console.log(result.message);
          } else {
            setDataSteps(result);
          }
        });
    }
  };

  async function validateDate() {
    const newValues = {
      quantidade_etapas_previstas: !dataProject.quantidade_etapas_previstas,
      quantidade_etapas_executadas: !dataProject.quantidade_etapas_executadas,
      historico_construtivo: !dataProject.historico_construtivo,
      metodo_construtivo: !dataProject.metodo_construtivo,
    };
    setValidationsProject(newValues);
    const isValid = Object.values(newValues).some(value => value);
    return !isValid;
  }

  const handleSave = async () => {
    setAlertInfo({ open: false, message: '', severity: 'success' });

    if (url.dam && url.project == 'new') {
      const isValid = await validateDate();
      if (isValid) {
        try {
          const responseProject = await ConstructiveProjectServices.create(dataProject, url.dam);
          if (!(responseProject instanceof Error)) {
            if (dataSteps.length > 0 && responseProject.uuid) {
              const response = await ConstructiveStepsServices.create(dataSteps, responseProject.uuid);
              if (response !== Error) {
                fetchDataProject();
                setAlertInfo({ open: true, message: 'Cadastro realizado!', severity: 'success' });
                setTimeout(() => {
                  window.history.back(); 
                }, 2000);
              } else {
                setAlertInfo({ open: true, message: 'Erro ao cadastrar!', severity: 'error' });
              }
            } else {
              setAlertInfo({ open: true, message: 'Cadastro do projeto realizado!', severity: 'success' });
              setTimeout(() => {
                window.history.back(); 
              }, 2000); 
            }
          } else {
            setAlertInfo({ open: true, message: 'Erro ao cadastrar projeto: ' + responseProject.message, severity: 'error' });
          }
        } catch (error: any) {
          console.error('Erro ao salvar o projeto:', error); 
          setAlertInfo({ open: true, message: 'Erro ao cadastrar!' + error.message, severity: 'error' });
        }
      }
    }

    if (url.project !== 'new' && url.dam && url.project) {
      const isValid = await validateDate();
      if (isValid) {
        try {
          let projectUpdateSuccess = false;
          const responseProject = await ConstructiveProjectServices.update(dataProject, url.project);

          if (!(responseProject instanceof Error)) {
            projectUpdateSuccess = true;
          } else {
            setAlertInfo({ open: true, message: 'Erro ao atualizar projeto: ' + responseProject.message, severity: 'error' });
            return; 
          }

          let stepsUpdateSuccess = true; 

          if (dataSteps.length > 0) {
            const responseSteps = await ConstructiveStepsServices.update(dataSteps, url.project);
            if (responseSteps instanceof Error) {
              setAlertInfo({ open: true, message: 'Erro ao atualizar etapa!' + responseSteps.message, severity: 'error' });
              stepsUpdateSuccess = false;
            }
          }

          if (projectUpdateSuccess && stepsUpdateSuccess) {
            fetchDataProject();
            setAlertInfo({ open: true, message: 'Atualização realizada!', severity: 'success' });
            setTimeout(() => {
              window.history.back();
            }, 2000); 
          } else if (!projectUpdateSuccess || !stepsUpdateSuccess) {
            setAlertInfo({ open: true, message: 'Atualização concluída com alguns erros.', severity: 'warning' });
          }

        } catch (error : any) {
          console.error('Erro ao atualizar o projeto:', error);
          setAlertInfo({ open: true, message: 'Erro ao atualizar!' + error.message, severity: 'error' });
        }
      }
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value, type, checked } = e.target;

    if (type === 'number' && parseFloat(value) < 0) {
      setDataProject(prevData => ({
        ...prevData,
        [id]: 0
      }));
    } else {
      const convertedValue = type === 'checkbox' ? checked : type === 'number' ? parseFloat(value) : value;
      setDataProject(prevData => ({
        ...prevData,
        [id]: convertedValue
      }));
    }
  };

  const handleChangeTeste = (e: React.ChangeEvent<HTMLInputElement>, index: number, field: string) => {
    const { value, type, checked } = e.target;

    setDataSteps(prevData => {
      const newDataSteps = [...prevData];

      if (type === 'number' && parseFloat(value) < 0) {

        newDataSteps[index] = {
          ...newDataSteps[index],
          [field]: 0
        };
      } else {

        const convertedValue = type === 'checkbox' ? checked : type === 'number' ? parseFloat(value) : value;
        newDataSteps[index] = {
          ...newDataSteps[index],
          [field]: convertedValue
        };
      }

      return newDataSteps;
    });
  };

  const handleAdd = () => {
    const newItem: IConstructiveProject = {};
    setDataSteps(prevDataSteps => [...prevDataSteps, newItem]);
  };

  const handleRemove = async () => {
    if (dataSteps.length > 0) {
      const lastStep = dataSteps[dataSteps.length - 1];
      const uuidToRemove = lastStep.uuid;
      if (uuidToRemove !== undefined) {
        const response = await ConstructiveStepsServices.deleteById(uuidToRemove);
        fetchDataSteps();
      }
      setDataSteps(prevDataSteps => prevDataSteps.slice(0, -1));
    }
  };

  const updateQuantidadeEtapasExecutadas = () => {
    setDataProject(prevDataProject => ({
      ...prevDataProject,
      quantidade_etapas_executadas: dataSteps.length,
    }));
  };

  useEffect(() => {
    updateQuantidadeEtapasExecutadas();
  }, [dataSteps]);

  return (
    <LayoutBase title='Características Técnicas do Projeto e da Construção'
      tollBar={
        <ToolsDetails
          showDeletButton={false}
          showNewButton={false}
          onClickSave={handleSave}
        />
      }
    >
      <Box>
        <Box margin={0} display={'flex'} flexDirection={'column'}>
          <Grid container direction={'column'} padding={2} spacing={2}>
            <Grid item >
              <Typography variant='h4'>Ficha de Construção</Typography>
            </Grid>
            <Grid container item direction={'row'} spacing={2}>
              <Grid item xs={12}>
                <TextField label='Histórico construtivo' id='historico_construtivo'
                  value={dataProject?.historico_construtivo}
                  onChange={handleChange}
                  error={validationsProject.historico_construtivo}
                  fullWidth multiline rows={4}
                  required />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth id='metodo_construtivo' label='Método construtivo'
                  value={dataProject?.metodo_construtivo}
                  onChange={handleChange}
                  error={validationsProject.metodo_construtivo}
                  required />
              </Grid>
              <Grid item xs={smDown ? 12 : 6}>
                <TextField label='Quantidade de etapas/alteamentos previstos'
                  id='quantidade_etapas_previstas' type='number'
                  fullWidth
                  value={dataProject?.quantidade_etapas_previstas}
                  onChange={handleChange}
                  error={validationsProject.quantidade_etapas_previstas}
                  required />
              </Grid>
              <Grid item xs={smDown ? 12 : 6}>
                <Tooltip title="Este valor é atualizado automaticamente conforme você adiciona ou remove etapas construtivas abaixo.">
                  <TextField
                    InputProps={{
                      sx: { borderColor: 'white' },
                      readOnly: true
                    }}
                    label='Quantidade de etapas/alteamentos executados'
                    id='quantidade_etapas_executadas'
                    type='number'
                    fullWidth
                    value={dataProject?.quantidade_etapas_executadas}
                    error={validationsProject.quantidade_etapas_executadas}
                    required
                  />
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Box padding={2}>
          {dataSteps.map((item, index) => (
            <Box paddingY={1} key={index}>
              <Accordion variant='outlined' sx={{ borderRadius: '25px' }}>
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <Typography>Etapa construtiva {index + 1}</Typography>
                </AccordionSummary>
                <AccordionSummary>
                  <Grid container spacing={2}>
                    <Grid item container spacing={2}>
                      <Grid item xs={smDown ? 12 : 6}>
                        <TextField label='Elevação (m)' type='number'
                          fullWidth id='elevacao'
                          onChange={(e) => handleChangeTeste(e as React.ChangeEvent<HTMLInputElement>, index, 'elevacao')}
                          value={item.elevacao} />
                      </Grid>
                      <Grid item xs={smDown ? 12 : 6}>
                        <TextField label='Empresa projetista'
                          fullWidth id='empresa_projetista'
                          onChange={(e) => handleChangeTeste(e as React.ChangeEvent<HTMLInputElement>, index, 'empresa_projetista')}
                          value={item.empresa_projetista} />
                      </Grid>
                    </Grid>
                    <Grid item container spacing={2}>
                      <Grid item xs={smDown ? 12 : 6}>
                        <TextField label='RT de projeto' fullWidth id='rt_projeto' onChange={(e) => handleChangeTeste(e as React.ChangeEvent<HTMLInputElement>, index, 'rt_projeto')} value={item.rt_projeto} />
                      </Grid>
                      <Grid item xs={smDown ? 12 : 6}>
                        <TextField label='Ano do projeto' fullWidth type='number' id='ano_projeto' onChange={(e) => handleChangeTeste(e as React.ChangeEvent<HTMLInputElement>, index, 'ano_projeto')} value={item.ano_projeto}
                          error={item.ano_projeto ? item.ano_projeto.toString().length < 4 : false}
                          helperText={item.ano_projeto ? (item.ano_projeto.toString().length < 4 ? 'Campo deve ter no mínimo 4 dígitos' : '') : ''}
                        />
                      </Grid>
                    </Grid>
                    <Grid item container spacing={2}>
                      <Grid item xs={smDown ? 12 : 6}>
                        <TextField label='Empresa Construtora' fullWidth id='empresa_construtora'
                          onChange={(e) => handleChangeTeste(e as React.ChangeEvent<HTMLInputElement>, index, 'empresa_construtora')}
                          value={item.empresa_construtora} />
                      </Grid>
                      <Grid item xs={smDown ? 12 : 6}>
                        <TextField label='RT de Obra' fullWidth id='rt_obra'
                          onChange={(e) => handleChangeTeste(e as React.ChangeEvent<HTMLInputElement>, index, 'rt_obra')}
                          value={item.rt_obra} />
                      </Grid>
                    </Grid>
                    <Grid item container spacing={2}>
                      <Grid item xs={smDown ? 12 : 6}>
                        <TextField label='Empresa Fiscalizadora (ATO)' fullWidth id='empresa_fiscalizadora_ato'
                          onChange={(e) => handleChangeTeste(e as React.ChangeEvent<HTMLInputElement>, index, 'empresa_fiscalizadora_ato')}
                          value={item.empresa_fiscalizadora_ato} />
                      </Grid>
                      <Grid item xs={smDown ? 12 : 6}>
                        <TextField label='RT de Fiscalização/ ATO' fullWidth id='rt_fiscalizacao_ato'
                          onChange={(e) => handleChangeTeste(e as React.ChangeEvent<HTMLInputElement>, index, 'rt_fiscalizacao_ato')}
                          value={item.rt_fiscalizacao_ato} />
                      </Grid>
                    </Grid>
                    <Grid item container spacing={2}>
                      <Grid item xs={smDown ? 12 : 6}>
                        <TextField label='Ano de construção' fullWidth type='number' id='ano_construcao'
                          onChange={(e) => handleChangeTeste(e as React.ChangeEvent<HTMLInputElement>, index, 'ano_construcao')} value={item.ano_construcao}
                          error={item.ano_construcao ? item.ano_construcao.toString().length < 4 : false}
                          helperText={item.ano_construcao ? (item.ano_construcao.toString().length < 4 ? 'Campo deve ter no mínimo 4 dígitos' : '') : ''}
                          required
                        />
                      </Grid>
                      <Grid item xs={smDown ? 12 : 6}>
                        <TextField label='As Built ou As Is' fullWidth id='as_built_as_is'
                          onChange={(e) => handleChangeTeste(e as React.ChangeEvent<HTMLInputElement>, index, 'as_built_as_is')}
                          value={item.as_built_as_is}
                        />
                      </Grid>
                    </Grid>
                    <Grid item container spacing={2}>
                      <Grid item xs={smDown ? 12 : 6}>
                        <TextField label='Empresa executora As Built ou As Is' fullWidth id='empresa_executora_as_built_as_is'
                          onChange={(e) => handleChangeTeste(e as React.ChangeEvent<HTMLInputElement>, index, 'empresa_executora_as_built_as_is')}
                          value={item.empresa_executora_as_built_as_is}
                        />
                      </Grid>
                      <Grid item xs={smDown ? 12 : 6}>
                        <TextField label='RT As Built ou As Is' fullWidth id='empresa_projetista'
                          onChange={(e) => handleChangeTeste(e as React.ChangeEvent<HTMLInputElement>, index, 'rt_as_built_as_is')}
                          value={item.rt_as_built_as_is} />
                      </Grid>
                    </Grid>
                    <Grid item container spacing={2}>
                      <Grid item xs={smDown ? 12 : 6}>
                        <TextField label='Ano As Built ou As Is' type='number' fullWidth
                          id='ano_as_built_as_is' onChange={(e) => handleChangeTeste(e as React.ChangeEvent<HTMLInputElement>, index, 'ano_as_built_as_is')}
                          value={item.ano_as_built_as_is}
                          error={item.ano_as_built_as_is ? item.ano_as_built_as_is.toString().length < 4 : false}
                          helperText={item.ano_as_built_as_is ? (item.ano_as_built_as_is.toString().length < 4 ? 'Campo deve ter no mínimo 4 dígitos' : '') : ''}
                          required />
                      </Grid>
                    </Grid>
                  </Grid>
                </AccordionSummary>
              </Accordion>
            </Box>
          ))}
        </Box>
        {alertInfo.open &&
          <CustomAlert
            message={alertInfo.message}
            severity={alertInfo.severity}
          />
        }
        <Box justifyContent='center' alignContent='center' flexDirection='row' width='100%' display='flex'>
          <Button startIcon={<Add />} onClick={handleAdd}>Adicionar</Button>
          <Button startIcon={<Remove />} onClick={handleRemove}>Remover</Button>
        </Box>
      </Box>
    </LayoutBase>
  );
};